import { UpdatedAppointmentInformation } from "@/Appointments/Api/Dto/Responses/UpdatedAppointmentInformation";
import { IRealTimeNotificationMessage } from "@/Common/Api/RealTimeNotification/Dto/RealTimeNotificationMessage";
import { RealTimeNotificationOperation } from "@/Common/Api/RealTimeNotification/Dto/RealTimeNotificationOperation";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RealTimeNotificationEventHandler } from "@/Common/Stores/Handlers/RealTimeNotificationEventHandler";
import { PAListStore } from "../PAListStore";

/**
 * Real-time notification update appointment message.
 */
interface IUpdateAppointmentMessage extends IRealTimeNotificationMessage {
    /**
     * Updated appointment DTO.
     */
    Appointment: UpdatedAppointmentInformation;
}

/**
 * Class representing the real-time notification handler for the PA List component.
 */
class PAListRealTimeNotificationHandler extends RealTimeNotificationEventHandler {
    /**
     * Create a PAListRealTimeNotificationHandler instance.
     * @param store The store where the real-time notification handler is going to be used.
     */
    constructor(store: BaseStore) {
        super(store);
        this.RegisterOperation(RealTimeNotificationOperation.UpdateAppointment, this.AppointmentUpdated);
    }

    /**
    * Triggers an appointment update in the PA List when the related real-time notification message is received.
    * @param message The message received when an appointment is updated.
    * @param store The store where an action will be triggered.
    */
    private AppointmentUpdated(message: IUpdateAppointmentMessage, store: PAListStore): void {
        store.PAListActions.ReloadAppointmentsInPAList(message.Appointment);
    }
}

export { PAListRealTimeNotificationHandler };
